export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";